import { BrowserRouter as Router, Routes, Route,} from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import {ChoosingACategory} from './pages/FindingAPractitioner/ChoosingACategory';
import {OldIndividualPage} from './pages/HomePage/oldIndividualPage';
import {PractitionerPage } from './pages/HomePage/Practitioner';
import {PractitionerLogin} from './pages/Practitioner/PractitionerLogin';
import {PractitionerSignUp} from './pages/Practitioner/PractitionerSignUp';
import {PrivacyPolicy} from './pages/Others/PrivacyPolicy'
import {Terms} from './pages/Others/Terms'
import {Navbar} from './components/Navbar';
import { HomePage } from './pages/HomePage/HomePage';
import { AboutCopyTest } from './pages/HomePage/AboutCopyTest';
import { NewPractitionerProfile} from './pages/Practitioner/newPractitionerProfile';
import { PractitionerListing } from './pages/FindingAPractitioner/PractitionerListing';
import { PractitionerProfileUserView } from './pages/FindingAPractitioner/PractitionerProfileUserView';
import ScrollToTop from './components/ScrollToTop';
import { ForgotPassword } from './pages/Practitioner/forgotPassword';
import { Admin } from './pages/HomePage/admin';
import CalendarPage from './pages/FindingAPractitioner/CalendarPage';
import {ForgotPasswordEmail} from './pages/Practitioner/forgotPasswordEmail'
import{Individual} from './pages/HomePage/Individual'
import {WaitlistRegister} from "./pages/user/waitlistRegister"
import {PelvicCareQuestion} from "./pages/user/pelvicCareQuestion"
import {SharePelvicCareStory} from "./pages/user/sharePelvicCareStory"
import AskMyEmployer from './pages/user/askMyEmployer';
import AdminEditPractitioners from './pages/HomePage/adminEditPractitioners';
import PelvicCareProgram from './pages/PelvicProgram/pelvicCareProgram';
import { PelvicSenseEmailCapture } from './pages/PelvicProgram/pelvicSenseEmailCapture';

function App() {
  return (
    <>
      <Router>
        <ScrollToTop>
          <Navbar/>
          <Routes>
            <Route path='/' element={<HomePage/>} />
            <Route path='/about' element={<AboutCopyTest/>}/>
            <Route path='/pelvicCareProgram' element={<PelvicCareProgram/>}/>
            <Route path='/pelvicSenseEmail' element={<PelvicSenseEmailCapture/>}/>
            <Route path='/Individual' element={<Individual/>}/>
            <Route path='/forgotPassword/:id/:token' element={<ForgotPassword/>}/>
            <Route path='/waitlistRegister' element={<WaitlistRegister/>}/>
            <Route path='/sharePelvicCareStory' element={<SharePelvicCareStory/>}/>
            <Route path='/pelvicCareQuestion' element={<PelvicCareQuestion/>}/>
            <Route path='/admin' element={<Admin/>}/>
            <Route path='/forgotPasswordEmail' element={<ForgotPasswordEmail/>}/> 
            <Route path='/oldIndividualPage' element={<OldIndividualPage/>}/>
            <Route path='/Practitioner' element={<PractitionerPage/>}/>
            <Route path='/terms' element={<Terms/>}/>
            <Route path='/privacyPolicy' element={<PrivacyPolicy/>}/>
            <Route path='/browse' element={<ChoosingACategory/>}/>
            <Route path='/practitionerSignUp' element={<PractitionerSignUp/>}/>
            <Route path='/practitionerLogin' element={<PractitionerLogin/>}/>
            <Route path='/calendar/:id' element={<CalendarPage/>}/>
            <Route path='/newPractitionerProfile' element={<NewPractitionerProfile/>}/>
            <Route path='/practitionerListing/:id' element={<PractitionerListing/>}/>
            <Route path='/practitionerProfileUserView/:practitioner_id' element={<PractitionerProfileUserView/>}/>
            <Route path='/employer' element={<AskMyEmployer/>} />
            <Route path='/admin/edit/:editPersonId' element={<AdminEditPractitioners/>} />
            
          </Routes>
      </ScrollToTop>
      </Router>
    </>
  );
}

export default App;
